import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AlertService, ModalService, ProxyService, TncVersionCheckCoordinatorService } from '@core/services';
import { Subscription } from 'rxjs';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';

@Component({
  selector: 'app-tnc-update',
  templateUrl: './tnc-update.component.html',
  styleUrls: ['./tnc-update.component.less'],
  providers: [AlertService],
})
export class TncUpdateComponent implements OnInit, OnDestroy {
  public termsContent: string;
  public loading: boolean;
  showTC = false;

  private subscriptions = new Subscription();

  constructor(
    private proxy: ProxyService,
    private modalService: ModalService,
    private cdr: ChangeDetectorRef,
    private alertService: AlertService,
    private tncVersionCheckCoordinator: TncVersionCheckCoordinatorService,
  ) {
    this.loading = false;
    this.getTermsAndConditionsText();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private getTermsAndConditionsText(): void {
    const reqParams = 'terms-conditions';
    this.subscriptions.add(
      this.proxy
        .httpGet(ApiRoutes.AUTH_TERMSANDCONDITIONS + reqParams)
        .subscribe(
          (success) => {
            this.termsContent = success.body.valueOf().toString();
            this.cdr.detectChanges();
          },
          (err) => {
            if (err.status === 200) {
              this.termsContent = err.error.text;
            } else {
              this.alertService.error(err.error?.message);
            }
            this.cdr.detectChanges();
          },
        ),
    );
  }

  public onViewTermsAndConditions(): void {
    this.showTC = true;
  }

  public onAccepted(): void {
    this.loading = true;
    this.cdr.detectChanges();
    this.subscriptions.add(
      this.proxy.httpPut(ApiRoutes.TNC_VERSION, null).subscribe(
        () => {
          this.loading = false;
          this.tncVersionCheckCoordinator.notifyTermsAccepted();
          this.modalService.hideModal();
          this.cdr.detectChanges();
          this.showTC = false;
        },
        (err) => {
          this.loading = false;
          this.alertService.error(
            err.error?.message ?? 'Something went wrong. Please try again.',
          );
          this.cdr.detectChanges();
        },
      ),
    );
  }
}